import { FormattedHTMLMessage } from 'react-intl';
import styled, { css } from 'styled-components';
import tw from 'tailwind.macro';
import TrustBox from '../../../../components/TrustBox/CustomTrustBox';
import { P0 } from '../../../../components/Typographies/Paragraph';
import { H2 } from '../../../../components/Typographies/Title';
import { ReactComponent as IconQuote } from '../../../../images/illustrated/quote-48.svg';
import { ReactComponent as IconSmile } from '../../../../images/illustrated/smile-48.svg';
import Cards from './Card';
import CustomerImages from './CustomerImages';
import { homePageReviewMessages } from './messages';

const Container = styled.div`
  ${tw`relative py-big flex flex-col`}
  gap:var(--size-big);

  @media (min-width: 768px) {
    gap: var(--size-huge2);
  }

  @media (min-width: 992px) {
    &:before {
      z-index: -1;
      content: ' ';
      position: absolute;
      background: radial-gradient(
        43.16% 43.16% at 50% 50%,
        rgba(215, 243, 229, 0.6) 0%,
        rgba(215, 243, 229, 0) 100%
      );
      width: 579.2109365188024px;
      right: -376px;
      top: 0px;
      border-radius: 0px;
      bottom: -363px;
    }

    &:after {
      z-index: -1;
      content: ' ';
      position: absolute;
      background: radial-gradient(
        43.16% 43.16% at 50% 50%,
        rgba(106, 73, 249, 0.15) 0%,
        rgba(215, 243, 229, 0) 100%
      );
      width: 579.2109365188024px;
      right: -376px;
      top: -363px;
      border-radius: 0px;
      bottom: 0;
    }
  }
`;

const Wrapper = styled.div`
  ${tw`flex flex-col lg:flex-row-reverse lg:justify-center`}
  gap: var(--size-medium);
  @media (min-width: 992px) {
    gap: var(--size-huge2);
  }
`;

const Title = styled(H2)`
  ${tw`text-center md:text-start`}
  .highlight {
    ${tw`text-primary-400 `}
  }
`;

const TitleIcon = styled(IconSmile)`
  transform: translateX(5px) translateY(-5px);
`;

const Content = styled.div`
  ${tw`flex flex-col mx-auto`}
  gap:var(--size-huge);
  max-width: 487px;
`;

const QuoteContainer = styled.div`
  ${tw`flex flex-col`}
  gap:var(--size-medium);
  max-width: 487px;
`;

const Quote = styled.div`
  ${tw`flex`}
  gap:var(--size-small);
`;

const QuoteImage = styled(IconQuote)`
  height: fit-content;
`;

const Review = () => (
  <Container>
    <Wrapper>
      <Content>
        <Title>
          <FormattedHTMLMessage {...homePageReviewMessages.reviewTitle} />
          <TitleIcon />
        </Title>
        <QuoteContainer>
          <Quote>
            <QuoteImage />
            <div>
              <P0>
                <FormattedHTMLMessage
                  {...homePageReviewMessages.reviewReactivityComment}
                />
              </P0>
              <TrustBox
                customStyle={css`
                  ${tw`mt-medium2 justify-start flex-wrap w-full`}
                `}
              />
            </div>
          </Quote>
        </QuoteContainer>
      </Content>

      <CustomerImages />
    </Wrapper>

    <Cards />
  </Container>
);

export default Review;
